import { styled } from '@mui/system';
import { Typography } from '@components/Typography';

const HeaderWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    padding: 24,
    width: '100%',
    '@media (max-width: 700px)': {
        flexDirection: 'column',
        gap: 0,
    },
});

// Sizes only the decorative header illustration. Keep svg sizing scoped here —
// a bare '& svg' on HeaderWrapper leaks into button/toggle icons rendered in
// the children and metrics slots.
const IconWrapper = styled('div')({
    display: 'flex',
    flexShrink: 0,
    '& svg': {
        width: 100,
        height: 100,
    },
});

const HeaderTextWrapper = styled('div')({
    width: 'inherit',
    '@media (max-width: 700px)': {
        display: 'flex',
        flexDirection: 'column',
    },
});

const Footer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 22,
    '@media (max-width: 700px)': {
        flexDirection: 'column',
    },
});

const ControlsWrapper = styled('div')({
    display: 'flex',
    gap: 8,
    '& a': {
        textDecoration: 'none',
    },
    '@media (max-width: 700px)': {
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
});

const PageHeader = ({ children, icon, title, subtitle, metrics, styles }) => {
    return (
        <HeaderWrapper style={styles}>
            {icon ? <IconWrapper>{icon}</IconWrapper> : null}
            <HeaderTextWrapper>
                <Typography
                    variant="h6"
                    color="textPrimary"
                    sx={{
                        '@media (max-width: 700px)': {
                            textAlign: 'center !important',
                        },
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        marginTop: '4px',
                        marginBottom: '16px',
                        color: 'var(--text-secondary)',
                        '@media (max-width: 700px)': {
                            textAlign: 'center !important',
                        },
                    }}
                >
                    {subtitle}
                </Typography>
                <Footer>
                    <ControlsWrapper className="page-header-controls">{children}</ControlsWrapper>
                    {metrics}
                </Footer>
            </HeaderTextWrapper>
        </HeaderWrapper>
    );
};

export default PageHeader;
